module.exports = __webpack_public_path__ + "assets/3de6096ddfb8468e5385695bf30ddc5d.mp3";